import { render, staticRenderFns } from "./SearchBannerFormSkeleton.vue?vue&type=template&id=360c2e24&scoped=true&"
import script from "./SearchBannerFormSkeleton.vue?vue&type=script&lang=ts&"
export * from "./SearchBannerFormSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./SearchBannerFormSkeleton.vue?vue&type=style&index=0&id=360c2e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360c2e24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360c2e24')) {
      api.createRecord('360c2e24', component.options)
    } else {
      api.reload('360c2e24', component.options)
    }
    module.hot.accept("./SearchBannerFormSkeleton.vue?vue&type=template&id=360c2e24&scoped=true&", function () {
      api.rerender('360c2e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/components/banner/skeletons/SearchBannerFormSkeleton.vue"
export default component.exports